import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Product.scss';

export default function Laptops() {
  const [laptops, setLaptops] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории laptops
        const laptopItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'laptops'
        );

        setLaptops(laptopItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="products">
      <h1>Ноутбуки</h1>
      <div className="products__list">
        {laptops.length > 0 ? (
          laptops.map((laptop) => (
            <div key={laptop.id} className="products__card">
              <img src={laptop.image} alt={laptop.name} />
              <h2>{laptop.name}</h2>
              <p className="specs">{laptop.description}</p>
              <p className="price">{laptop.price}</p>
              <Link to={`/laptops/${laptop.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
